module.exports = __webpack_public_path__ + "img/children.542e847a.jpg";